<template>
  <div class="selectWrapper clear" >
    <div class="selectItem l clear" v-for="(item,index) in searchItem" :key="index" >
      <div class="choose l">
        <selectc class="multi" :noChange="item.option.noChange" @onSelectChange="changeList(index)" v-model="item.option" :list="item.list"></selectc>
      </div>
      <div v-if="item.option.type==='select'" class="select l"> <!--下拉列表选择-->
        <selectc class="multi multiMax" v-model="item.value" :list="item.option.list"></selectc>
      </div>
      <div v-if="item.option.type==='input'" class="input l"  > <!--输入框-->
        <inputc v-model="item.value"  :maxl="item.option.maxl" :ref="item.option.ref[0]" :replace="item.option.replace" :tipMsg="item.option.msg" :rules=item.option.rules @enter="onEnter(item.option.ref[0])"></inputc>
      </div>
      <div v-if="item.option.type==='range'" class="range clear l"> <!--输入框区间选择框-->
        <div class="rangeInput l">
          <inputc v-model="item.minValue" :maxl="item.option.maxl" :ref="item.option.ref[0]" :replace="item.option.replace" :tipMsg="item.option.startmsg" :rules=item.option.rules @enter="onEnter(item.option.ref[0])"></inputc>
        </div>
        <div class="rangeIco l">-</div>
        <div class="rangeInput l">
          <inputc v-model="item.maxValue" :maxl="item.option.maxl" :ref="item.option.ref[1]" :replace="item.option.replace" :tipMsg="item.option.endmsg" :rules=item.option.rules @enter="onEnter(item.option.ref[1])"></inputc>
        </div>
      </div>
      <div v-if="item.option.type==='area'" class="location clear l">
        <div class="area l"> <!--省-->
          <selectc class="multi" v-if="area.province" ref="province" @onSelectChange="selectProvince" :list="area.province" v-model="item.selectedProvince"></selectc>
        </div>
        <div class="area l"> <!--市-->
          <selectc class="multi" v-if="area.city" ref="city" @onSelectChange="selectCity" :list="area.city" v-model="item.selectedCity"></selectc>
        </div>
        <div class="area l"> <!--区-->
          <selectc class="multi" v-if="area.area" @onSelectChange="selectArea" :list="area.area" v-model="item.selectedArea"></selectc>
        </div>
      </div>
      <div class="l">
        <div v-show="index===searchItem.length - 1" class="multiSelectBtn clear">
          <input type="button" class="searchBtn l" value='搜索' @click="getParameters" />
          <input type="button" class="add btnSelect l" @click="addSearchItem" v-show="searchItem.length!=maxLength"/>
          <input type="button" class="reduce btnSelect l" @click="deleteSearchItem" v-show="searchItem.length!=1 && searchItem.length>num"/>
        </div>
        <div class="multiSelectBtn" v-if="index%2 !== 0 && index!==searchItem.length - 1"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Input from './input.vue'
  import Select from './select.vue'
  import {msg} from '../common/config'
  import {validateUtil} from '../common/ValidateUtil.js';
  import {CommonUtil} from '../common/CommonUtil.js';
  import $ from 'jquery'
  Vue.component('selectc', Select)
  Vue.component('inputc', Input)

  export default {
    name: 'multiSelect',
    data: function () {
      return {
        num:1,
        init:1,
        searchItem:[], //搜索项列表
      };
    },
    props: ['choose', 'maxLength', 'area','minItem','maxl','initItem'],
   beforeMount: function () {
     this.initView();
   },
   methods: {
     initView: function(){
           this.num = 1;
           this.init = 1;
           this.searchItem = [];
           this.minItem?this.num=this.minItem:this.num=1
           this.initItem?this.init=this.initItem:this.init=1
           if (this.init < this.num) {
             this.init = this.num
           }
           for(var i = 0; i<this.init; i++) {
             this.addSearchItem();
           }
     },
      onEnter: function (curRef) {
        var configEle=[]
        var config = []
        for(var i = 0; i < this.searchItem.length; i++) {
          if (this.searchItem[i].option.type === 'input' || this.searchItem[i].option.type === 'range') {
            configEle.push(...this.searchItem[i].option.ref)
          }
        }
        for (var i = 0; i < configEle.length; i++) {
          config.push(this.$refs[configEle[i]][0])
        }

        var nextEl = CommonUtil.getNextEL(this.$refs[curRef][0], config, false);
        if (nextEl) {
          $(nextEl).focus();
        } else {
          $('.searchBtn').focus()
        }
      },

      changeList(index) {
        this.updateOptionSelectList(3, index);
      },
      addSearchItem: function () { //添加搜索项
        if(this.searchItem.length > this.maxLength){//如果超出最大搜索项数量，不做任何操作
          return;
        }
        var firstItem = this.getFirstItem();
        var item = {};
        item.option = firstItem;
        this.searchItem.push(item);
        this.updateOptionSelectList(1);
        this.$emit('itemNumber',this.searchItem.length)
      },
      deleteSearchItem: function () {//删除搜索项
        if(this.searchItem.length  == 0){//如果搜索项数量为0，不做任何操作
          return;
        }
        this.searchItem.splice(this.searchItem.length-1, 1);
        this.updateOptionSelectList(2);
        this.$emit('itemNumber',this.searchItem.length)
      },

      //更新各选项列表, type: 1 新增 2 删除 3 修改   index: type是修改时对应的index
      updateOptionSelectList:function (type, index) {
        for(let j = 0; j < this.searchItem.length; j++){
          var unionSelectList = this.getLeftSelectList(j);
          var originList = [];
          var copiedChoose = CommonUtil.copyArr(this.choose, true);
          for(var i =0; i <copiedChoose.length; i ++){
            if(this.searchItem[j].option.desc === copiedChoose[i].desc){
              originList.push(copiedChoose[i]);
            }
          }
//          var list = originList.concat(unionSelectList);
          var list = unionSelectList;
          Vue.set(this.searchItem[j],'list',list)
          //新增时初始化新选项，或者修改时初始化被修改项
          if((type == 1 && j == this.searchItem.length -1) ||
            (type==3 && index == j)){
            if(this.searchItem[j].option.type === 'select'){
              Vue.set(this.searchItem[j], 'value', this.searchItem[j].option.list[0])
            }else if(this.searchItem[j].option.type === 'input'){
              Vue.set(this.searchItem[j], 'value', '')
            }else if(this.searchItem[j].option.type === 'range'){
              Vue.set(this.searchItem[j], 'minValue', '')
              Vue.set(this.searchItem[j], 'maxValue', '')
            }else if(this.searchItem[j].option.type === 'area'){
              Vue.set(this.searchItem[j], 'selectedProvince', {desc:'省', value:''})
              Vue.set(this.searchItem[j], 'selectedCity', {desc:'市', value:''})
              Vue.set(this.searchItem[j], 'selectedArea', {desc:'区', value:''})
            }
          }
        }
      },

      getFirstItem() {
        var leftSelectList = this.getLeftSelectList();
        return leftSelectList[0];
      },
      getLeftSelectList: function (index) {
        var result = [];
        var copiedChoose = CommonUtil.copyArr(this.choose, true);
        var copiedSearchItem = CommonUtil.copyArr(this.searchItem, true);
        if (index !== undefined) {
          copiedSearchItem.splice(index,1)
        }
        for(var k = 0; k <copiedChoose.length; k++){
          var exist = false;
          for(var i = 0; i<copiedSearchItem.length; i++){
            if(copiedChoose[k].desc === copiedSearchItem[i].option.desc){
              exist = true;
            }
          }
          if(!exist){
            result.push(copiedChoose[k]);
          }
        }
        return result;
      },
      selectProvince:function (target) {
        for(var i = 0; i < this.searchItem.length; i ++){
          if(this.searchItem[i].option.type == 'area'){
            Vue.set(this.searchItem[i], 'selectedCity',{desc:'市', value:''});
            Vue.set(this.searchItem[i], 'selectedArea', {desc:'区', value:''});
          }
        }
        this.$emit('selectProvince', target);
      },
      selectCity: function (target) {
        for(var i = 0; i < this.searchItem.length; i ++){
          if(this.searchItem[i].option.type == 'area'){
             this.searchItem[i].selectedArea = {desc:'区', value:''};
          }
        }
        this.$emit('selectCity', target)
      },
      selectArea: function (target) {
        this.$emit('selectArea', target)
      },
      updateSelectList:function(desc){

        for(var i = 0; i < this.searchItem.length; i ++){
           if(this.searchItem[i].option.desc == desc){
            this.searchItem[i].value = this.searchItem[i].option.list[0];
           }
        }
      },
      getParameters(){
        var result = this.validate()
        var parameters={}
        for(var i = 0; i < this.searchItem.length; i ++){
          if(this.searchItem[i].option.type === 'select'){
            parameters[this.searchItem[i].option.name]=this.searchItem[i].value.value
          }else if(this.searchItem[i].option.type === 'input'){
            parameters[this.searchItem[i].option.name]=this.searchItem[i].value
          }else if(this.searchItem[i].option.type === 'range'){
            parameters['min'+this.searchItem[i].option.name]=this.searchItem[i].minValue
            parameters['max'+this.searchItem[i].option.name]=this.searchItem[i].maxValue
          }else if(this.searchItem[i].option.type === 'area'){
            parameters['province']=this.searchItem[i].selectedProvince.value
            parameters['city']=this.searchItem[i].selectedCity.value
            parameters['area']=this.searchItem[i].selectedArea.value
          }
        }
        if (result !== false) {
       //   $('.showTableHead').css({'paddingRight':0,'display':'none'})
          this.$emit('search',parameters,'click')
          return parameters
        } else {
          return null
        }
      },
      validate (){ //验证多想选项的值
        for(var i = 0; i < this.searchItem.length; i ++){
          var ele = this.searchItem[i]
          if (ele.option.type === 'input') {
            var result = validateUtil.validate(ele.option.rules,ele.value);
            if (result) {
              ele.value=''
              ele.option.msg = result
              return false
            }
          } else if (this.searchItem[i].option.type === 'range') {
            var startresult = validateUtil.validate(ele.option.rules,ele.minValue);
            var endresult = validateUtil.validate(ele.option.rules,ele.maxValue);
            if (startresult && endresult) {
              if (startresult) {
                ele.minValue=''
                ele.option.startmsg = startresult
                return false
              } else if(endresult){
                ele.maxValue=''
                ele.option.endmsg = endresult
                return false
              }
            }
          } else if (this.searchItem[i].option.type === 'select') {

          } else if (this.searchItem[i].option.type === 'area') {
            if(!ele.selectedProvince.value){
              this.$refs.province[0].showList()
              return false
            } else if (!ele.selectedCity.value) {
              this.$refs.city[0].showList()
              return false
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
  .selectWrapper {
    position: relative;
    z-index:100;
    font-size: 16px;
  }

  .multiSelectBtn {
    margin-left: 5px;
  }
  .range {
    width: 260px;
    height: 30px;
  }
  .choose {
    width: 90px;
    height: 32px;
    margin-right: -1px;
    border: 1px solid #d2d2d2;
  }
  .rangeInput {
    width: 123px;
    height: 32px;
  }
  .input {
    width: 260px;
    height: 32px;
  }
  .select {
    width: 260px;
    height: 32px;
    border: 1px solid #d2d2d2;
  }
  .rangeIco {
    height: 30px;
    text-align: center;
    display: inline-block;
    width: 14px;
    line-height: 30px;
  }
  .selectItem {
    height: 32px;
    margin-right: 5px;
  }
  .btnSelect {
    height: 30px;
    width: 36px;
    cursor: pointer;
    margin-left: 5px;
    background-size: contain;
    border: none;
  }
  .searchBtn {
    width: 62px;
    height: 32px;
    line-height: 30px;
    border: solid 1px #b9b9b9;
    background: #fff;
    color: #000;
    font-size: 16px;
    vertical-align: top;
    cursor:pointer;
  }
  .add {
    background: url("../assets/images/add.png") center no-repeat;
  }
  .reduce {
    background: url("../assets/images/reduce.png") center no-repeat;
  }
  .location {
    width: 260px;
    height: 32px;
  }
  .area {
    width: 85px;
    height: 32px;
    margin-right: -1px;
    border: 1px solid #d2d2d2;
  }
</style>
